import styled from 'styled-components';

export const HeadTitle = styled.div`
  font-weight: 700;
  font-size: 36px;
  line-height: 44px;
  color: #000000;
`;
